import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../Utils/Auth";
import Topimg from "../../Assets/Topimgg.png";
import userIcon from "../../Assets/user-iconn.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExchangeAlt,
  faSquarePlus,
  faExclamationTriangle,
  faRecycle,
  faTachometerAlt,
  faUser,
  faLandmark,

  faCloud,
  faAngleDown,
  faAngleRight,
  faCircle,
  faReceipt,
  faCommentDots,
  faWallet,

} from "@fortawesome/free-solid-svg-icons";
import './sideMenu.css'
const SideMenu = ({ onSelect }) => {
  const auth = useAuth();
  const [isToggle, setIsToggle] = useState(true);
  const [isToggleCreate, setIsToggleCreate] = useState(true);
  const [isToggleDash, setIsToggleDash] = useState(true);
  const [useremail, setUserEmail] = useState([]);
  const [userrole, setUserRole] = useState([]);
  const [IsToggleTransaction, setIsToggleTransaction] = useState(true);
  const [IsToggleRequest, setIsToggleRequest] = useState(true);
  const [IsToggleBank, setIsToggleBank] = useState(true);
  const [IsToggleWebsite, setIsToggleWebsite] = useState(true);
  const [isToggleRecycleBin, setIsToggleRecycleBin] = useState(true);

  useEffect(() => {
    setUserEmail(auth?.user?.userName);
    setUserRole(auth?.user?.roles);
  }, [auth]);

  const handleToggle = () => {
    setIsToggle(!isToggle);
  };
  const handleToggleDash = () => {
    setIsToggleDash(!isToggleDash);
  };
  const handleToggleCreate = () => {
    setIsToggleCreate(!isToggleCreate);
  };
  const handleToggleTransaction = () => {
    setIsToggleTransaction(!IsToggleTransaction);
  };
  const handleToggleRequest = () => {
    setIsToggleRequest(!IsToggleRequest);
  };
  const handleToggleBank = () => {
    setIsToggleBank(!IsToggleBank);
  };
  const handleToggleWebsite = () => {
    setIsToggleWebsite(!IsToggleWebsite);
  };
  const handleToggleRecycleBin = () => {
    setIsToggleRecycleBin(!isToggleRecycleBin);
  };
  const handleMenuClick = (menuItem) => {
    onSelect(menuItem);
  };

  return (
    <div>
      <aside
        className="main-sidebar elevation-4"
        style={{
          backgroundColor: "#4682b4",
          minHeight: "100vh",
        }}
      >
        {/* Brand Logo */}
        <div className="d-flex flex-row align-items-center">
          <div className="brand-link d-flex align-items-center">
            <img
              src={Topimg}
              alt="AdminLTE Logo"
              className="brand-image img-circle elevation-3"
              style={{ opacity: ".8", width: "40px", height: "40px" }}
            />
            <span className="brand-text font-weight-light text-white ms-2">
              Hobhiasb
            </span>
            <span
              className="fs-4 ms-4  d-xl-none"
              style={{ width: "15%" }}
              data-widget="pushmenu"
            >
              &#10005;
            </span>
          </div>
        </div>

        {/* User Panel */}
        <div className="sidebar">
          <div className="user-panel mt-3 pb-3 mb-3 d-flex align-items-center">
            <div className="image">
              <img
                src={userIcon}
                className="img-circle"
                alt="User Image"
                style={{ width: "40px", height: "40px" }}
              />
            </div>
            <div className="info ms-2">
              <p className="text-white m-0" style={{ fontSize: "14px" }}>
                {useremail}
              </p>
            </div>
          </div>

          {/* Navigation Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Dashboard */}
              <li className="nav-item">
                <Link
                  to="/welcome"
                  className="nav-link active"
                  onClick={() => handleMenuClick("Dashboard")}
                  style={{ color: "white" }}
                >
                  <FontAwesomeIcon
                    icon={faTachometerAlt}
                    className="nav-icon"
                    style={{ color: "white" }}
                  />
                  <p style={{ color: "white" }}>Dashboard</p>
                </Link>
              </li>

              {/* Transaction Section */}
              {userrole.some(
                (role) =>
                  role === "superAdmin" ||
                  role === "Deposit" ||
                  role === "Withdraw" ||
                  role === "Bank-Transfer" ||
                  role === "Bank-Transfer-Request"
              ) && (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      onClick={handleToggleTransaction}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      <FontAwesomeIcon
                        icon={faWallet}
                        className="nav-icon"
                        style={{ color: "white" }}
                      />
                      <p style={{ color: "white" }}>
                        Transaction
                        <FontAwesomeIcon
                          icon={IsToggleTransaction ? faAngleRight : faAngleDown}
                          className="right"
                          style={{ color: "white" }}
                        />
                      </p>
                    </a>
                    <ul
                      className="nav nav-treeview"
                      style={{ display: IsToggleTransaction ? "none" : "block" }}
                    >
                      {userrole.some(
                        (role) => role === "superAdmin" || role === "Deposit"
                      ) && (
                          <li className="nav-item custom-hover">
                            <Link
                              to="/deposit"
                              className="nav-link"
                              onClick={() => handleMenuClick("Deposit")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon icon-white"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>Deposit</p>
                            </Link>
                          </li>
                        )}
                      {userrole.some(
                        (role) => role === "superAdmin" || role === "Withdraw"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/withdraw"
                              className="nav-link"
                              onClick={() => handleMenuClick("Withdraw")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>Withdraw</p>
                            </Link>
                          </li>
                        )}

                      {userrole.some(
                        (role) =>
                          role === "superAdmin" || role === "Bank-Transfer"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/bank_To_bankTransfer"
                              className="nav-link"
                              onClick={() => handleMenuClick("Bank To Bank Transfer")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>Bank Transfer</p>
                            </Link>
                          </li>
                        )}


                      {userrole.some(
                        (role) =>
                          role === "superAdmin" ||
                          role === "Bank-Transfer-Request"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/bank_To_bank_transfer_request"
                              className="nav-link"
                              onClick={() => handleMenuClick("Bank To Bank Transfer Request")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>Transfer Request</p>
                            </Link>
                          </li>
                        )}
                    </ul>
                  </li>
                )}

              {/* Bank Section */}
              {userrole.some(
                (role) => role === "superAdmin" || role === "Bank-Page-View"
              ) && (
                  <li className="nav-item">
                    <Link
                      to="/bank"
                      className="nav-link"
                      onClick={() => handleMenuClick("Bank")}
                      style={{ color: "white" }}
                    >
                      <FontAwesomeIcon
                        icon={faLandmark}
                        className="nav-icon"
                        style={{ color: "white" }}
                      />
                      <p style={{ color: "white" }}>Bank</p>
                    </Link>
                  </li>
                )}

              {/* Website Section */}
              {userrole.some(
                (role) => role === "superAdmin" || role === "Website-Page-View"
              ) && (
                  <li className="nav-item">
                    <Link
                      to="/website"
                      className="nav-link"
                      onClick={() => handleMenuClick("Website")}
                      style={{ color: "white" }}
                    >
                      <FontAwesomeIcon
                        icon={faCloud}
                        className="nav-icon"
                        style={{ color: "white" }}
                      />
                      <p style={{ color: "white" }}>Website</p>
                    </Link>
                  </li>
                )}

              {/* Create Section */}
              {userrole.some(
                (role) =>
                  role === "superAdmin" ||
                  role === "Create-User" ||
                  role === "Create-Introducer" ||
                  role === "Create-Sub-Admin"
              ) && (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      onClick={handleToggleCreate}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      <FontAwesomeIcon
                        icon={faSquarePlus}
                        className="nav-icon"
                        style={{ color: "white" }}
                      />
                      <p style={{ color: "white" }}>
                        Create
                        <FontAwesomeIcon
                          icon={isToggleCreate ? faAngleRight : faAngleDown}
                          className="right"
                          style={{ color: "white" }}
                        />
                      </p>
                    </a>
                    <ul
                      className="nav nav-treeview"
                      style={{ display: isToggleCreate ? "none" : "block" }}
                    >
                      {userrole.some(
                        (role) => role === "superAdmin" || role === "Create-User"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/createactualuser"
                              className="nav-link"
                              onClick={() => handleMenuClick("Create User")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>User</p>
                            </Link>
                          </li>
                        )}
                      {userrole.some(
                        (role) =>
                          role === "superAdmin" || role === "Create-Introducer"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/createintroducer"
                              className="nav-link"
                              onClick={() => handleMenuClick("Create Introducer")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>Introducer</p>
                            </Link>
                          </li>
                        )}
                      {userrole.some((role) => role === "superAdmin") && (
                        <li className="nav-item">
                          <Link
                            to="/createuser"
                            className="nav-link"
                            onClick={() => handleMenuClick("Create Subadmin")}
                            style={{ color: "white" }}
                          >
                            <FontAwesomeIcon
                              icon={faCircle}
                              className="nav-icon"
                              style={{ color: "white", fontSize: "8px" }}
                            />
                            <p style={{ color: "white" }}>Sub Admin</p>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

              {/* Profile Section */}
              {userrole.some(
                (role) =>
                  role === "superAdmin" ||
                  role === "Sub-Admin-Profile-View" ||
                  role === "Introducer-Profile-View" ||
                  role === "User-Profile-View"
              ) && (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      onClick={handleToggle}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      <FontAwesomeIcon
                        icon={faUser}
                        className="nav-icon"
                        style={{ color: "white" }}
                      />
                      <p style={{ color: "white" }}>
                        Profile
                        <FontAwesomeIcon
                          icon={isToggle ? faAngleRight : faAngleDown}
                          className="right"
                          style={{ color: "white" }}
                        />
                      </p>
                    </a>
                    <ul
                      className="nav nav-treeview"
                      style={{ display: isToggle ? "none" : "block" }}
                    >
                      {userrole.some(
                        (role) =>
                          role === "superAdmin" ||
                          role === "User-Profile-View"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="userprofile"
                              className="nav-link"
                              onClick={() => handleMenuClick("User Profile")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>User</p>
                            </Link>
                          </li>
                        )}
                      {userrole.some(
                        (role) =>
                          role === "superAdmin" ||
                          role === "Introducer-Profile-View"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/introducerprofile"
                              className="nav-link"
                              onClick={() => handleMenuClick("Introducer Profile")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>Introducer</p>
                            </Link>
                          </li>
                        )}
                      {userrole.some(
                        (role) => role === "superAdmin" 
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/adminlist"
                              className="nav-link"
                              onClick={() => handleMenuClick("Subadmin Profile")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>Sub Admin</p>
                            </Link>
                          </li>
                        )}
                    </ul>
                  </li>
                )}

              {/* Report Section */}
              {userrole.some(
                (role) =>
                  role === "superAdmin" ||
                  role === "All-Transaction-Report" ||
                  role === "My-Transaction-Report"
              ) && (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      onClick={handleToggleDash}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      <FontAwesomeIcon
                        icon={faReceipt}
                        className="nav-icon"
                        style={{ color: "white" }}
                      />
                      <p style={{ color: "white" }}>
                        Report
                        <FontAwesomeIcon
                          icon={isToggleDash ? faAngleRight : faAngleDown}
                          className="right"
                          style={{ color: "white" }}
                        />
                      </p>
                    </a>
                    <ul
                      className="nav nav-treeview"
                      style={{ display: isToggleDash ? "none" : "block" }}
                    >
                      {userrole.some(
                        (role) =>
                          role === "superAdmin" || role === "All-Transaction-Report"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/mainfiltertransactionpage"
                              className="nav-link"
                              onClick={() =>
                                handleMenuClick("All Transaction Details")
                              }
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>
                                All &nbsp;Transactions{" "}
                              </p>
                            </Link>
                          </li>
                        )}
                      {userrole.some(
                        (role) =>
                          role === "superAdmin" || role === "My-Transaction-Report"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/mytxn"
                              className="nav-link"
                              onClick={() => handleMenuClick("My Transactions Details")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>My Transactions</p>
                            </Link>
                          </li>
                        )}
                    </ul>
                  </li>
                )}

              {/* Request Section */}
              {userrole.some(
                (role) => role === "superAdmin" || role === "All-Transaction-Request" || role === "Introducer-Transaction-Request" || role === "Bank-Requests" || role === "Website-Requests"
              ) && (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      onClick={handleToggleRequest}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      <FontAwesomeIcon
                        icon={faCommentDots}
                        className="nav-icon"
                        style={{ color: "white" }}
                      />
                      <p style={{ color: "white" }}>
                        Request
                        <FontAwesomeIcon
                          icon={IsToggleRequest ? faAngleRight : faAngleDown}
                          className="right"
                          style={{ color: "white" }}
                        />
                      </p>
                    </a>
                    <ul
                      className="nav nav-treeview"
                      style={{ display: IsToggleRequest ? "none" : "block" }}
                    >
                      {userrole.some(
                        (role) =>
                          role === "superAdmin" || role === "All-Transaction-Request"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/allTransactionRequest"
                              className="nav-link"
                              onClick={() => handleMenuClick("All Transaction Request")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>All Transaction</p>
                            </Link>
                          </li>
                        )}

                      {userrole.some(
                        (role) =>
                          role === "superAdmin" || role === "Introducer-Transaction-Request"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to="/introduceralert"
                              className="nav-link"
                              onClick={() =>
                                handleMenuClick("Introducer Transaction Request")
                              }
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="nav-icon"
                                style={{ color: "white", fontSize: "8px" }}
                              />
                              <p style={{ color: "white" }}>Introducer Transaction</p>
                            </Link>
                          </li>
                        )}



                      {userrole.some(
                        (role) =>
                          role === "superAdmin" || role === "Bank-Requests"
                      ) && (
                      <li className="nav-item">
                        <Link
                          to="/bankRequests"
                          className="nav-link"
                          onClick={() => handleMenuClick("Bank Requests")}
                          style={{ color: "white" }}
                        >
                          <FontAwesomeIcon
                            icon={faCircle}
                            className="nav-icon"
                            style={{ color: "white", fontSize: "8px" }}
                          />
                          <p style={{ color: "white" }}>Bank Requests</p>
                        </Link>
                      </li>
                      )}

                    {userrole.some(
                      (role) =>
                        role === "superAdmin" || role === "Website-Requests"
                    ) && (
                        <li className="nav-item">
                          <Link
                            to="/WebsiteRequests"
                            className="nav-link"
                            onClick={() => handleMenuClick("Website Requests")}
                            style={{ color: "white" }}
                          >
                            <FontAwesomeIcon
                              icon={faCircle}
                              className="nav-icon"
                              style={{ color: "white", fontSize: "8px" }}
                            />
                            <p style={{ color: "white" }}>Website Requests</p>
                          </Link>
                        </li>
                      )}

                      {/* {userrole.some(
                      (role) =>
                        role === "superAdmin" || role === "RequestAdmin"
                    ) && (
                      <li className="nav-item">
                        <a 
                          className="nav-link" 
                          onClick={handleToggleBank}
                          style={{ cursor: "pointer", color: "white" }}
                        >
                          <FontAwesomeIcon icon={faLandmark} className="nav-icon" style={{ color: "white", fontSize: "11px" }} />
                          <p style={{ color: "white" }}>
                            Bank
                            <FontAwesomeIcon 
                              icon={IsToggleBank ? faAngleRight : faAngleDown} 
                              className="right" 
                              style={{ color: "white" }}
                            />
                          </p>
                        </a>
                        <ul className="nav nav-treeview" style={{ display: IsToggleBank ? "none" : "block",  }}>
                          <li className="nav-item">
                            <Link
                              to="/bankEdit"
                              className="nav-link"
                              onClick={() => handleMenuClick("BankEdit")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon icon={faCircle} className="nav-icon" style={{ color: "white", fontSize: "8px" }} />
                              <p style={{ color: "white" }}>Edit</p>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="/bankDelete"
                              className="nav-link"
                              onClick={() => handleMenuClick("BankDelete")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon icon={faCircle} className="nav-icon" style={{ color: "white", fontSize: "8px" }} />
                              <p style={{ color: "white" }}>Delete</p>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="/newbank"
                              className="nav-link"
                              onClick={() => handleMenuClick("NewBank")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon icon={faCircle} className="nav-icon" style={{ color: "white", fontSize: "8px" }} />
                              <p style={{ color: "white" }}>New Bank</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    )}
                    {userrole.some(
                      (role) =>
                        role === "superAdmin" || role === "RequestAdmin"
                    ) && (
                      <li className="nav-item">
                        <a 
                          className="nav-link" 
                          onClick={handleToggleWebsite}
                          style={{ cursor: "pointer", color: "white" }}
                        >
                          <FontAwesomeIcon icon={faCloud} className="nav-icon" style={{ color: "white", fontSize: "11px" }} />
                          <p style={{ color: "white" }}>
                            Website
                            <FontAwesomeIcon 
                              icon={IsToggleWebsite ? faAngleRight : faAngleDown} 
                              className="right" 
                              style={{ color: "white" }}
                            />
                          </p>
                        </a>
                        <ul className="nav nav-treeview" style={{ display: IsToggleWebsite ? "none" : "block",  }}>
                          <li className="nav-item">
                            <Link
                              to="/websiteEdit"
                              className="nav-link"
                              onClick={() => handleMenuClick("WebsiteEdit")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon icon={faCircle} className="nav-icon" style={{ color: "white", fontSize: "8px" }} />
                              <p style={{ color: "white" }}>Edit</p>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="/websiteDelete"
                              className="nav-link"
                              onClick={() => handleMenuClick("WebsiteDelete")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon icon={faCircle} className="nav-icon" style={{ color: "white", fontSize: "8px" }} />
                              <p style={{ color: "white" }}>Delete</p>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="/newwebsite"
                              className="nav-link"
                              onClick={() => handleMenuClick("newWebsite")}
                              style={{ color: "white" }}
                            >
                              <FontAwesomeIcon icon={faCircle} className="nav-icon" style={{ color: "white", fontSize: "8px" }} />
                              <p style={{ color: "white" }}>New Website</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    )} */}
                    </ul>
                  </li>
                )}

              {/* Recycle Bin Section */}
              {userrole.some(
                (role) => role === "superAdmin" || role === "Recycle-Bin-View"
              ) && (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      onClick={handleToggleRecycleBin}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      <FontAwesomeIcon
                        icon={faRecycle}
                        className="nav-icon"
                        style={{ color: "white" }}
                      />
                      <p style={{ color: "white" }}>
                        Recycle Bin
                        <FontAwesomeIcon
                          icon={isToggleRecycleBin ? faAngleRight : faAngleDown}
                          className="right"
                          style={{ color: "white" }}
                        />
                      </p>
                    </a>
                    <ul
                      className="nav nav-treeview"
                      style={{ display: isToggleRecycleBin ? "none" : "block" }}
                    >
                      <li className="nav-item">
                        <Link
                          to="trashAllTransaction"
                          className="nav-link"
                          onClick={() => handleMenuClick("All Transaction Trash")}
                          style={{ color: "white" }}
                        >
                          <FontAwesomeIcon
                            icon={faCircle}
                            className="nav-icon"
                            style={{ color: "white", fontSize: "8px" }}
                          />
                          <p style={{ color: "white" }}>All Transaction</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default SideMenu;